/**
 * Shared theme base — the token bundle every persona theme is built from (Brand core V13).
 *
 * The base is the **socle commun** the book describes: marine, jaune signature, progression,
 * Outfit, la trame d'espace et de rayons. It is persona-neutral — it does not presume a
 * universe. Each persona file spreads it and repoints only what its universe owns
 * (`role`, and for the parent the page surface). Same component code, different tokens.
 *
 * Primitives read `theme.colors.primary`, `theme.spacing['4']`, `theme.radius.lg`,
 * `theme.fontFamilies.bold`, `theme.fontSizes['text-lg']`, etc.
 */
import { semantic } from "./tokens/colors"
import { elevation } from "./tokens/elevation"
import { motion } from "./tokens/motion"
import { radius } from "./tokens/radius"
import { spacing } from "./tokens/spacing"
import { fontFamilies, fontSizes } from "./tokens/typography"

export const baseTheme = {
    colors: {
        ...semantic,
    },
    spacing,
    radius,
    elevation,
    motion,
    fontFamilies,
    fontSizes,
} as const

export type AppTheme = typeof baseTheme
